import { notify } from "@/lib/notify";

import type { ClaimWithRelations } from "../api/use-claim";

/** Port of utils/open-tribunal-digital-procedure.ts (Vue). */
export function openTribunalDigital(procedure: ClaimWithRelations["procedure"]) {
  if (!procedure) {
    notify.error("Aucun numéro RG rattaché au dossier");
    return;
  }
  const juridictionCode = procedure.juridiction.code;
  const numeroRG = procedure.identifier;
  const urlAffaire = `https://www.tribunaldigital.fr/front-td/app/procedure/detail?juridiction=${juridictionCode}&numeroRG=${numeroRG}&isAffaireAdded=false`;
  window.open(urlAffaire, "_blank", "noopener,noreferrer")?.focus();
}
